// extracted by mini-css-extract-plugin
export default {"slideWrapper":"effectSlider_slideWrapper__iZCj9","nextButton":"effectSlider_nextButton__+MDxV","prevButton":"effectSlider_prevButton__8hAwX"};